import React from 'react'
import PropTypes from 'prop-types'
import * as PIXI from 'pixi.js'
import { getLocalTexture, getSpinesFromStage } from '../../utils'
import ImgFromTexture from '../../components/imgFromTexture'

function playAnimation(spineName, animName, loop) {
  const allSpines = getSpinesFromStage(spineName)
  allSpines.forEach(spine => {
    if (spine.visible) {
      spine.state.setAnimation(0, animName, loop)
    }
  })
}

function stopAnimations(spineName) {
  const allSpines = getSpinesFromStage(spineName)
  allSpines.forEach(spine => {
    spine.state.clearTrack(0)
    spine.skeleton.setToSetupPose()
  })
}

function queueAnimation(spineName, animation) {
  const allSpines = getSpinesFromStage(spineName)
  allSpines.forEach(spine => {
    const currentTrack = spine.state.getCurrent(0)
    const isComplete = currentTrack && currentTrack.isComplete()
    const isLooping = currentTrack && currentTrack.loop

    if (!isComplete && !isLooping) {
      spine.state.addAnimation(0, animation, false, 0)
    } else {
      spine.state.setAnimation(0, animation, false)
    }
  })
}

export default class SpineSelector extends React.Component {
  static propTypes = {
    textureName: PropTypes.string.isRequired,
    isSpine: PropTypes.bool,
  }

  static defaultProps = {
    isSpine: false,
  }

  getAnimations = (spineName) => {
    const spine = PIXI.Loader.shared.resources[spineName]
    if (spine) {
      const animations = []
      Object.keys(spine.data.animations).forEach(key => {
        animations.push(key)
      })
      return animations
    }
    return []
  }

  /* eslint-disable compat/compat */
  async loadSpineAssets(event) {
    const { files = {} } = event.target
    let atlas
    let json
    const images = []
    this.currentSpineRead = {
      images: [],
      atlas,
      json,
    }

    if (files.length > 0) {
      Object.keys(files).forEach(f => {
        const fileType = files[f].name.split('.')[1]
        if (fileType === 'atlas') {
          atlas = files[f]
        } else if (fileType === 'json') {
          json = files[f]
        } else if (fileType === 'png') {
          images.push(files[f])
        }
      })
    }

    const promises = []
    promises.push(
      this.readFile('atlas', atlas),
      this.readFile('json', json),
    )

    images.forEach(i => {
      promises.push(this.readFile('image', i))
    })
    await Promise.all(promises)

    this.props.replaceSpines(this.currentSpineRead, this.props.textureName)
  }

  readFile = (fileType, file) => {
    return new Promise(resolve => {
      const reader = new FileReader()

      reader.addEventListener('load', (event) => {
        if (fileType === 'image') {
          this.currentSpineRead.images.push({ name: file.name, src: event.target.result })
        } else {
          this.currentSpineRead[fileType] = event.target.result
        }
        resolve()
      })

      reader.readAsDataURL(file)
    })
  }
  /* eslint-enable compat/compat */

  render() {
    const { textureName, textures } = this.props
    const fileName = textureName.split('_atlas_page_')
    const animations = this.getAnimations(fileName[0])

    return (
      <div className="spineSelector">
        <div className="skeleton">
          <div>Original skeleton: </div>
          <div className="skeletonName">{`${fileName[fileName.length - 1].split('.')[0]}`}</div>
        </div>
        <div className="images">
          { textures.map(t => (
            <ImgFromTexture
              width={100}
              height={100}
              texture={getLocalTexture(t.textureCacheIds[0])}
              key={t.textureCacheIds[0]}
            />
          ))}
        </div>
        <div className="fileSelection">
          <input className="replacementControls" type="file" id={textureName} accept=".json,.atlas,.png" onChange={(e) => { this.loadSpineAssets(e) }} multiple />
        </div>
        <div className="animations">
          <div className="title">ANIMATIONS:</div>
          <div className="list" style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <input id="stop" type="button" value="Stop animations" onClick={() => { stopAnimations(fileName[0]) }} />
              { animations.map(anim => (
                <div key={anim} className="animation">
                  <p>{`${anim}`}</p>
                  <input type="button" value="Play once" onClick={() => { playAnimation(fileName[0], anim, false) }} />
                  <input type="button" value="Loop" onClick={() => { playAnimation(fileName[0], anim, true) }} />
                  <input type="button" value="Queue" onClick={() => { queueAnimation(fileName[0], anim, false) }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
